import React from 'react';

const Snowflake = (props) =>{
	return(
		<p className='ssus-stars' id={`item${props.id}`} style={props.style}>
			*
		</p>
	)
}

const Stars = (props) => {

	let animationDelay = '0s';
	let fontSize = '100px';
	let transform = '35deg';
	let arr = Array.from( 'Let us place some stars in the galaxy. And sure, we can have so many of them! Stars are so wonderful and so is the galaxy.' );

	return (
		<div className="galaxy-stars">
		{
			arr.map( ( el, i ) => {
				animationDelay = `${(Math.random()*16).toFixed(2)}s`;
				fontSize = `${(Math.floor(Math.random()*10) + 10)}px`;
				transform = `rotate(${(Math.floor(Math.random()*10) + 55)}deg)`;
				
				let style = {
					animationDelay,
					fontSize,
					transform
				}

				return (
					<Snowflake key={i} id={i} style={style} />
				);
			} )
		}
		</div>
	);
}

export default Stars;